import { Spinner, Modal } from "react-bootstrap";
import { useContext } from "react";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";
import GetParsedDate from "../shared/GetParsedDate";
import { useNavigate } from "react-router-dom";
import {
  useRef,
  useCallback,
  useState,
  useEffect,
  Fragment,
  ImageSourcePropType,
} from "react";
import SignatureCanvas from "react-signature-canvas";
import useAxiosPrivateUploadFile from "../../hooks/useAxiosPrivateUploadFile";
import HandleHttpErrors from "../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API;

const convertBase64ToPNG = (base64String) => {
  const imageType = `image/png;base64,${base64String}`;
  return { uri: imageType };
};

const Signature = ({
  visible,
  moamad,
  hagsha_aharon,
  menuVisible,
  setMenuVisible,
  inSignCanvas,
  setInSignCanvas,
  languagesNum,
  coursesNum,
  relativesNum,
  educationNum,
  workExperienceNum,
  recommandsNum,
  documentsNum,
}) => {
  console.log("mmmmmm:", moamad);
  let history = useNavigate();
  const sigCanvas = useRef({});
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [error, setError] = useState(false);
  const [isUpdeted, SetIsUpdeted] = useState(false);
  const axiosPrivate = useAxiosPrivateUploadFile();
  const [imageSource, setImageSource] = useState(null);
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [loading, setLoading] = useState(false);
  const [showBrief, setShowBrief] = useState(false);
  const [isCanvasEmpty, setIsCanvasEmpty] = useState(true);
  let formData = new FormData();

  const now = new Date(Date.now());
  const ahron = new Date(
    new Date(Date.parse(hagsha_aharon) + 24 * 60 * 60 * 1000).setHours(
      0,
      1,
      0,
      0
    )
  );
  let canSign = moamad.signature_date == null && ahron > now;
  const clear = () => {
    sigCanvas.current.clear();
    setTrimmedDataURL(null);
    setIsCanvasEmpty(true);
  };

  const send = async (e) => {
    setLoading(true);
    const tDataURL = sigCanvas.current
      .getTrimmedCanvas()
      .toDataURL("image/png");
    setTrimmedDataURL(tDataURL);
    setImageSource(tDataURL);
    const file = await fetch(tDataURL)
      .then((res) => res.blob())
      .then((blob) => new File([blob], "signature.png", { type: "image/png" }));
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "jobs/signmoamadoot/" + moamad.id + "/",
          { signature: file },
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          SetIsUpdeted(true);
          setLoading(false);
          moamad.signature_date = response.data.signature_date;
          moamad.signature = response.data.Signature;

          canSign = false;
          setShowBrief(false);
          alert("הצעתך למועמדות למשרה נחתמה בהצלחה.");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    //setTitle("");
    setError(false);
  };

  const handleTouchStart = (e) => {
    setInSignCanvas((prevState) => true); // Set inSignCanvas to true directly
    console.log("Touch event in", inSignCanvas); // This will log the previous value of inSignCanvas
  };

  const handleTouchEnd = () => {
    // Set menuVisible back to true when done interacting with SignatureCanvas
    setInSignCanvas(false);
    console.log("Touch event out");
  };

  if (!visible) return;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />
          <br />
          אם הפעולה מתארכת ולא מתקבל מייל לתיבת המייל שלך
          <br /> נא ליצור קשר עם משאבי אנוש לוודא חתימת ההצעה.
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <Fragment>
        <Modal show={showBrief} backdrop="static" keyboard={false}>
          <Modal.Header style={{ textAlign: "center" }}>
            <Modal.Title>
              <span
                className="blinking-text"
                style={{ color: "red", fontWeight: "bolder" }}
              >
                רגע לפני שאתה מאשר את ההצעה, <br />
                בדוק את התמצית הנ"ל
              </span>
              <br />
              ברגע שההצעה נחתמת, לא תוכל לעדכן אותה.
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table>
              <thead>
                <tr>
                  <th>תיאור</th>
                  <th className="right-aligned-row rightmargin">
                    &nbsp;מספר/מצב
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ידיעת שפות: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      languagesNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {languagesNum === 0
                      ? "לא הצהרת על ידיעת שפות!!!"
                      : languagesNum}
                  </td>
                </tr>
                <tr>
                  <td> ההשכלה: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      educationNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {educationNum === 0
                      ? "לא הצהרת על  ההשכלה שלך!!!"
                      : educationNum}
                  </td>
                </tr>
                <tr>
                  <td>קורסים והשתלמויות: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      coursesNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {coursesNum === 0
                      ? "לא הצהרת על קורסים והשתלמיות!!!"
                      : coursesNum}
                  </td>
                </tr>
                <tr>
                  <td> נסיון תעסוקתי: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      workExperienceNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {workExperienceNum === 0
                      ? "לא הצהרת על  נסיונך התעסוקתי!!!"
                      : workExperienceNum}
                  </td>
                </tr>
                <tr>
                  <td> קרובי המשפחה: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      relativesNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {relativesNum === 0
                      ? "לא הצהרת על קרובי משפחה!!!"
                      : relativesNum}
                  </td>
                </tr>
                <tr>
                  <td> ממליצים: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      recommandsNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {recommandsNum === 0
                      ? "לא הצהרת על  הממלצים!!!"
                      : recommandsNum}
                  </td>
                </tr>
                <tr>
                  <td> מסמכים: </td>
                  <td
                    className={`right-aligned-row rightmargin ${
                      documentsNum === 0 ? "text-true" : "text-false"
                    }`}
                  >
                    &nbsp;
                    {documentsNum === 0 ? "לא הגשת מסמכים !!!" : documentsNum}
                  </td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
            <button
              disabled={!canSign}
              className="btn btn-success btn-lg"
              style={{ margin: "5px" }}
              onClick={send}
            >
              אישור ההצעה
            </button>
            <button
              className="btn btn-danger btn-lg"
              style={{ margin: "5px" }}
              onClick={() => {
                setShowBrief(false);
              }}
            >
              ביטול
            </button>
          </Modal.Footer>
        </Modal>

        <center>
          <div>
            {" "}
            <br />
            <HelpModal />
            <h3
              onClick={() => {
                setSaeef("1003");
                setShowHelp(true);
              }}
            >
              הצהרה ושליחת טופס
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
            <b style={{ display: "inline-block", maxWidth: "600px" }}>
              <br />
              אני מציע/ה את מועמדתי למשרה הפנויה הנ"ל, ומצהיר/ה בזה כי כל הפרטים
              בטופס המקוון ובמסמכים הנילווים (ככל שהוגשו), הם נכונים, שלמים
              ומדוייקים, וכי אין לי יחסי קירבה משפחתית פרט לאנשים שפורטו בתוך
              טופס זה
            </b>
          </div>
          {canSign ? (
            <div>
              <SignatureCanvas
                ref={sigCanvas}
                penColor="blue"
                backgroundColor="white"
                canvasProps={{
                  width: "300%",
                  height: 200,
                  className: "sigCanvas",
                }}
                onBegin={() => {
                  setInSignCanvas((prevState) => true);
                }}
                onEnd={() => {
                  // Check if canvas is empty after drawing
                  const isEmpty = sigCanvas.current.isEmpty();
                  setIsCanvasEmpty(isEmpty);
                }}
              />
              <hr />
              <button
                disabled={!canSign}
                className="btn btn-danger btn-lg"
                style={{ margin: "5px" }}
                onClick={clear}
              >
                ניקוי החתימה
              </button>
              <button
                disabled={!canSign || isCanvasEmpty}
                className="btn btn-success btn-lg"
                style={{ margin: "5px" }}
                onClick={() => setShowBrief(true)}
              >
                שליחת טופס
              </button>
              <br />
              <button
                className="btn btn-primary btn-lg"
                style={{ margin: "5px" }}
                onClick={() => history(-1)}
              >
                חזרה להצעות
              </button>
            </div>
          ) : (
            <div>
              <label style={{ color: "black" }}>
                תאריך חתימה/שיגור הטופס:{" "}
              </label>
              <span className="bold-text">
                {"  " +
                  GetParsedDate({
                    strDate: moamad.signature_date,
                    withTime: true,
                  })}
              </span>

              <br />

              <img src={moamad.signature} />
            </div>
          )}
        </center>
      </Fragment>
    );
  }
};

export default Signature;
